module.exports = __webpack_public_path__ + "img/tray-meal-svgrepo-com.0d9a2dab.svg";